export const SYSTEM_FONT =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif'

/**
 * Font family design tokens.
 *
 * Typically defined as an array of scaled numerical pixel values, here we've
 * decided to define fontSizes as aliases pointing to rem value strings.
 *
 * For use with the following CSS properties:
 *
 *     font-family, font
 *
 * @see https://system-ui.com/theme
 */
export const fonts = {
  body: SYSTEM_FONT,
  buttons: SYSTEM_FONT,
  formLabels: SYSTEM_FONT,
  headings: SYSTEM_FONT,
  primary: SYSTEM_FONT,
  monospace: 'Menlo, monospace',
}

/**
 * Font size design tokens.
 *
 * Typically defined as an array of scaled numerical pixel values, here we've
 * decided to define fontSizes as aliases pointing to rem value strings.
 *
 * For use with the following CSS properties:
 *
 *     font-size, font
 *
 * @see https://system-ui.com/theme
 */
export const bodyFontSize = '16px'
export const fontSizes = {
  xxxlarge: '5rem', // 80px
  xxlarge: '2.625rem', // 42px
  xlarge: '1.625rem', // 26px
  large: '1.25rem', // 20px
  body: '1rem', // 16px
  small: '0.875rem', // 14px
  smaller: '0.8125rem', // 13px
  little: '0.75rem', // 12px
  tiny: '0.6875rem', // 11px
  tinier: '0.625rem', // 10px
  micro: '0.5rem', // 8px
}

/**
 * Font weight design tokens.
 *
 * For use with the following CSS properties:
 *
 *     font-weight, font
 *
 * @see https://system-ui.com/theme
 */
export const fontWeights = {
  light: 300,
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
}

/**
 * Line height design tokens.
 *
 * For use with the following CSS properties:
 *
 *     line-height, font
 *
 * @see https://system-ui.com/theme
 */
export const lineHeights = [
  0.75,
  0,
  1,
  1.25,
  1.5,
  1.75,
  2,

  /* Prism line-heights */
  1.2,
  1.3,
  1.4,
  1.6,
]
